import {
  Box,
  Button,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useContext, useState } from "react";
import { AuthContext } from "../../Context/AuthProvider";
import LoadingSpinner from "../../LoadingSpinner";
import logo from "../../media/logo.jpg";
import EventCall from "../../utils/EventCall";

// eslint-disable-next-line react/prop-types
const SignOutModal = ({ isOpen, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { handleLogOut } = useContext(AuthContext);

  const handleYes = () => {
    const ObjectPayload = {
      Event: "Logout",
      Message: "User logged out",
    };
    setIsLoading(true);
    EventCall("/api/postLog", ObjectPayload);
    window.open("/.auth/logout", "_blnk");
    setTimeout(() => {
      handleLogOut();
      setIsLoading(false);
      localStorage.removeItem("disclaimer_shown");
      onClose();
    }, 1500);
  };

  return (
    <div>
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="sm">
        <ModalOverlay />
        <ModalContent borderRadius="none" height="420px">
          <ModalBody>
            {isLoading ? (
              <LoadingSpinner />
            ) : (
              <Flex
                mt={6}
                alignItems="center"
                justifyContent="center"
                direction="column"
              >
                <Image
                  src={logo}
                  height="100px"
                  width="100px"
                  borderRadius="50%"
                />
                <Box mt="50px" textAlign="center">
                  <Text fontWeight={500} fontSize="md">
                    You are leaving.
                  </Text>
                  <Text fontWeight={700} fontSize="lg">
                    Are you sure to leave ?
                  </Text>
                </Box>
              </Flex>
            )}
          </ModalBody>
          {!isLoading && (
            <ModalFooter>
              <Flex w="full" gap="5px">
                <Button
                  w="full"
                  borderRadius="none"
                  colorScheme="red"
                  mr={3}
                  onClick={onClose}
                >
                  No
                </Button>
                <Button
                  width="full"
                  variant="primaryButton"
                  onClick={() => handleYes()}
                >
                  Yes
                </Button>
              </Flex>
            </ModalFooter>
          )}
        </ModalContent>
      </Modal>
    </div>
  );
};

export default SignOutModal;
